<template>
  <li class="compliance-category">
    <div :class="categoryStatusClass">
    </div>
    <div class="category-name">
      <slot />
    </div>
    <div class="line"></div>
  </li>
</template>
<script>
import complianceItemBase from './ComplianceItemBase.vue'

export default {
  extends: complianceItemBase,
}
</script>
<style>
.compliance-category {
  font-weight: bold;
  position: relative;
  display: inline-block;
  margin: 0 0 1em 2em;
}


.category-item{
  font-size: 16px;
}

.compliance-category:after {
  position: absolute;
  content: '';
  left: -29px;
  /* start just below the category dot (dot top = 34% of li, dot = 2em @14px
     + 4px border = 32px) and run to the first item's top edge (through the
     1em margin-bottom). Wrap-proof: both anchors are relative to this li. */
  top: calc(34% + 32px);
  bottom: -1em;
  width: 2px;
  background-color: #dbdde0;
}
.compliance-category:not(:first-child) {
  margin-top: 28px;
}
.category-name{
  padding-top: 20px;
}

.cat-pending, .cat-completed, .cat-incomplete{
  position: absolute;
  top: 34%;
  left: -3.2em;
  border-radius: 50%;
  z-index: 1;
  box-sizing: content-box;
  height: 2em;
  width: 2em;
}

.cat-incomplete{
  border: 2px solid #4a4a4a;
  background-color: #4a4a4a;
}

.cat-pending{
  border: 2px solid green;
  background-color: #FFF;
}


.cat-completed{
  border: 2px solid green;
  background-color: green;
}

.cat-completed:after{
  position: absolute;
  content: " ";
  display: block;
  top: 18%;
  left: 0.7em;
  height: 1.2em;
  width: 0.5em;
  border: solid white;
  border-width: 0 0.3em 0.3em 0;
  margin-top: -0.2em;
  -webkit-transform: rotate(45deg); 
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}

</style>